import { taipeiDay } from '@/utils/taipeiTime';

/** 諮詢預約狀態（API 英文 → 後台顯示中文；日曆卡用三字避免截斷） */
export const consultationBookingStatusMeta = {
    confirmed: { color: 'gold', label: '待諮詢' },
    pending: { color: 'processing', label: '配對中' },
    completed: { color: 'success', label: '已完成' },
    cancelled: { color: 'default', label: '已取消' },
    no_show: { color: 'error', label: '未到場' }
};

export function getConsultationBookingStatusMeta(status) {
    return (
        consultationBookingStatusMeta[status] || {
            color: 'default',
            label: status || '—'
        }
    );
}

/** 單行：YYYY-MM-DD HH:mm-HH:mm（日期只出現一次） */
export function formatConsultationTimeRange(startsAt, endsAt) {
    if (!startsAt) return '—';
    const start = taipeiDay(startsAt);
    if (!start.isValid()) return String(startsAt);
    const datePart = start.format('YYYY-MM-DD');
    const startTime = start.format('HH:mm');
    const end = endsAt ? taipeiDay(endsAt) : null;
    if (end?.isValid()) {
        return `${datePart} ${startTime}-${end.format('HH:mm')}`;
    }
    return `${datePart} ${startTime}`;
}
